// TODO: Remove file in COTECH-2882
/**
 * This is to check if UCP is updated with new odyssey wrapper for the top leaderboard.
 *
 * @link https://github.com/Wikia/unified-platform/pull/21474
 *
 * @returns True if the top leaderboard has an additional odyssey wrapper, false otherwise.
 */
export function tlbHasAdditionalOdysseyWrapper(): boolean {
  return document.querySelector(".top_leaderboard-odyssey-wrapper") !== null;
}
